import { Button, Popover, Progress, Tag, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { AiOutlineExport, AiOutlineInfoCircle } from "react-icons/ai";
import { BiStoreAlt } from "react-icons/bi";
import * as XLSX from "xlsx";

const formatEffectType = (type) => {
  if (!type) return "";

  return type
    .toLowerCase() // stamp_card
    .replace(/_/g, " ") // stamp card
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Stamp Card
};

export default function MagiccodeCard({
  title,
  secrets,
  status,
  date,
  expires,
  stats,
  effects,
}) {
  const { t } = useTranslation();
  console.log(stats);

  const claimed = stats?.claimed || 0;
  const limit = stats?.limit || 0;
  const remaining = limit - claimed;
  const percent = limit ? Math.round((claimed / limit) * 100) : 0;

  const exportSecretsToExcel = () => {
    const worksheetData = secrets?.map((secret, index) => ({
      [t("index")]: index + 1,
      [t("secret")]: secret,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Secrets");

    const safeDate = date?.replace(/[^\w\s]/gi, "_").replace(/\s+/g, "_");
    const fileName = `${t("magic_codes")}_${safeDate || t("unknown_date")}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  /** ✅ Effects Content (Reusable) */
  const effectsContent = (
    <div className="effects-popover">
      {effects?.length > 0 ? (
        effects.map((effect, index) => (
          <div key={index} className="effect-item">
            <div className="effect-type">{formatEffectType(effect.type)}</div>{" "}
            <div className="effect-summary">{effect.summary}</div>
            <div className="effect-meta">
              {t("quantity")}: {effect.quantity}
            </div>
          </div>
        ))
      ) : (
        <span>{t("no_effects")}</span>
      )}
    </div>
  );

  return (
    // <Popover content={effectsContent} trigger="hover">
    <div className="outlet-card magic_code-card hoverable">
      <BiStoreAlt className="outlet-card-icon" size={48} />

      <div className="outlet-card-content">
        {/* Header */}
        <div className="magic-code-header">
          <h5>
            {t("name")}: <span className="active">{title}</span>
            {/* ✅ Info icon */}
            {effects?.length > 0 && (
              <Popover content={effectsContent} trigger="click" placement="top">
                <AiOutlineInfoCircle className="info-icon" />
              </Popover>
            )}
          </h5>

          <h6 className={status?.toLowerCase()}>{status}</h6>
        </div>

        {/* Dates */}
        <h6>
          {t("created_at")}: <span className="active">{date}</span>
        </h6>
        <h6>
          {t("expires_in")}:{" "}
          <span className="active">{expires || t("never")}</span>
        </h6>

        {/* Stats */}
        <div className="stats-container">
          <div className="stat">
            <span>{t("claimed")}</span>
            <strong>{claimed}</strong>
          </div>

          <div className="stat">
            <span>{t("limit")}</span>
            <strong>{limit}</strong>
          </div>

          <div className="stat">
            <span>{t("remaining")}</span>
            <strong>{remaining}</strong>
          </div>
        </div>

        {/* ✅ Better Progress (Ant Design) */}
        <Progress
          percent={percent}
          size="small"
          strokeColor={{
            "0%": "#f11e69",
            "100%": "#ff7aa2",
          }}
          showInfo={false}
        />

        {/* Secrets */}
        {secrets?.length > 0 && (
          <div className="secrets-container">
            <div className="secrets-header">
              <h6>{t("magic_codes")}:</h6>
              <Tooltip title={t("export_secrets_to_excel")}>
                <Button
                  icon={<AiOutlineExport />}
                  onClick={exportSecretsToExcel}
                  size="small"
                  type="primary"
                />
              </Tooltip>
            </div>

            <div className="secrets-tags">
              {secrets.map((secret, index) => (
                <Tag color="#F11E69" key={index}>
                  {secret}
                </Tag>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
    // </Popover>
  );
}
